/** GraphQL Mutation to update cart totals */
export default `
  mutation updateCartTotals($input: UpdateCartTotalsInput) {
    updateCartTotals(input: $input) {
      cart {
        id
        prices {
          tax_amount
          subtotal_excluding_tax {
            value
          }
          subtotal_including_tax {
            value
          }
          applied_taxes {
            label
            amount {
              value
            }
            percent
            rates {
              percent
              title
            }
          }
          discounts {
            amount {
              value
            }
            label
          }
          grand_total {
            value
          }
          fees {
            value
          }
          vw_cod_fee {
            value
          }
        }
        shipping_addresses {
          selected_shipping_method {
            carrier_code
            carrier_title
            method_code
            method_title
            amount {
              value
              currency
            }
            amount_incl_tax {
              value
              currency
            }
          }
        }
      }
    }
  }
`;
